import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

import { DisplayMusicByToken } from "@/components/DisplayMusic";
export default function HallDisplay() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get(`/displays/public/${token}`).then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [token]);
  if (!d) return <div className="min-h-screen flex items-center justify-center bg-black text-[#A8A398]">Lade …</div>;
  const st = d.current_showtime;
  return (
    <>
      <DisplayMusicByToken token={token} autoStart hideToggle />
      <div className="min-h-screen bg-black flex items-center justify-center text-[#F5F0E6] p-10">
      <div className="text-center">
        <div className="text-xs uppercase tracking-[0.4em] text-[#A8A398]">{d.hall || st?.hall || "Saal"}</div>
        <div className="font-heading text-8xl text-[#D4AF37] mt-4">{d.hall || st?.hall}</div>
        {st && (
          <div className="mt-10 space-y-3">
            <div className="font-heading text-4xl">{st.movie?.title_de}</div>
            <div className="text-xl text-[#A8A398]">Einlass {st.entry_time} · Start {st.start_time} · Ende ~{st.end_time}</div>
            <div className="mt-6 text-sm uppercase tracking-widest text-[#D4AF37]">Status: {st.status}</div>
          </div>
        )}
      </div>
    </div>
  
    </>);
}
